import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAdminCourseInstructors } from "../../api/admin/courseInstructor.api"; // Adjust this relative import path to match your layout folder tree

export const fetchCourseInstructors = createAsyncThunk(
  "courseInstructor/fetchCourseInstructors",
  async (courseId = null, { rejectWithValue }) => {
    try {
      // Wraps the raw courseId value argument into the destructured configuration object your API layer expects
      const response = await getAdminCourseInstructors({ course_id: courseId });

      if (!response.success) {
        return rejectWithValue(response.message);
      }

      // Return the full payload containing the structured data array to the fulfilled slice builder receiver 
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || "Something went wrong while pulling target instructor parameters."
      );
    }
  }
);